import { ComponentWithAs, Icon, IconProps } from '@chakra-ui/react'

const IconComp: ComponentWithAs<'svg', IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon {...props}>
      <path
        d="M11 21.6666L0.333313 10.9999L11 0.333252L12.9 2.19992L5.43331 9.66658H21.6666V12.3333H5.43331L12.9 19.7999L11 21.6666Z"
        fill="currentColor"
      />
    </Icon>
  )
}
IconComp.defaultProps = {
  viewBox: '0 0 22 22',
  boxSize: '22px',
}

export default IconComp
